import { applyTimezone } from "../../../../utils/helpers/date";

export const formatSubmittedData = (company, values) => {
	const {
		name,
		employeeNumberLength,
		employeeNumberType,
		defaultEmployeeNumber,
		executivePayrollEmailAddress,
		settings,
		logo,
		backgroundImage,
		badgeIdLength,
	} = values;

	return {
		...company,
		badgeIdLength,
		name: name,
		employeeNumberLength,
		defaultEmployeeNumber,
		executivePayrollEmailAddress,
		logo,
		backgroundImage,
		settings: {
			...company.settings,
			...settings,
			employeeNumberType,
			countries: settings.countries.map((country) => country.id),
			timezone: settings.timezone.id,
			maxShiftLength: Number(settings?.maxShiftLength),
			...(settings?.faceRecognition
				? {
						faceRecognition: {
							...settings.faceRecognition,
							enabled: !!settings.faceRecognition.enabled,
							requireLiveness: !!settings.faceRecognition.requireLiveness,
							temporaryFaceEnabled:
								settings.faceRecognition.temporaryFaceEnabled !== false,
							pendingFaceValidityDays:
								settings.faceRecognition.pendingFaceValidityDays != null &&
								settings.faceRecognition.pendingFaceValidityDays !== ""
									? Number(settings.faceRecognition.pendingFaceValidityDays)
									: undefined,
							approvalRequestExpirationDays:
								settings.faceRecognition.approvalRequestExpirationDays != null &&
								settings.faceRecognition.approvalRequestExpirationDays !== ""
									? Number(
											settings.faceRecognition.approvalRequestExpirationDays,
									  )
									: undefined,
						},
				  }
				: {}),
			schedule: {
				...settings?.schedule,
				shiftStart: applyTimezone(
					values?.settings?.schedule?.shiftStart, 
					company?.settings?.timezone?.value,
				    true
				).toISOString(true),
				shiftEnd: applyTimezone(
					values?.settings?.schedule?.shiftEnd, 
					company?.settings?.timezone?.value,
					true
				).toISOString(true)
			}
		},
	};
};
